// First value is Make, second is model and this is year
var makeObject = {
  "Ford": {
    "3.0L Powerstroke": {
      "2018":["2018-2021-ford-3-0l-powerstroke"],
      "2019":["2018-2021-ford-3-0l-powerstroke"],
      "2020":["2018-2021-ford-3-0l-powerstroke"],
      "2021":["2018-2021-ford-3-0l-powerstroke"]
    },
    "3.2L Powerstroke": {
      "2015":["2015-2020-transit-3-2l-powerstroke"],
      "2016":["2015-2020-transit-3-2l-powerstroke"],
      "2017":["2015-2020-transit-3-2l-powerstroke"],
      "2018":["2015-2020-transit-3-2l-powerstroke"],
      "2019":["2015-2020-transit-3-2l-powerstroke"],
      "2020":["2015-2020-transit-3-2l-powerstroke"]
    },
    "6.0L Powerstroke": {
      "2003":["2003-2007-6-0l-powerstroke"], 
      "2004":["2003-2007-6-0l-powerstroke"], 
      "2005":["2003-2007-6-0l-powerstroke"], 
      "2006":["2003-2007-6-0l-powerstroke"], 
      "2007":["2003-2007-6-0l-powerstroke"]
    },
    "6.4L Powerstroke": {
      "2008":["2008-2010-6-4l-powerstroke"], 
      "2009":["2008-2010-6-4l-powerstroke"], 
      "2010":["2008-2010-6-4l-powerstroke"]
    },
    "6.7L Powerstroke": {
      "2011":["2011-2016-6-7l-powerstroke"],
      "2012":["2011-2016-6-7l-powerstroke"],
      "2013":["2011-2016-6-7l-powerstroke"],
      "2014":["2011-2016-6-7l-powerstroke"],
      "2015":["2011-2016-6-7l-powerstroke"],
      "2016":["2011-2016-6-7l-powerstroke"],
      "2017":["2017-2022-6-7l-powerstroke"],
      "2018":["2017-2022-6-7l-powerstroke"],
      "2019":["2017-2022-6-7l-powerstroke"],
      "2020":["2017-2022-6-7l-powerstroke"],
      "2021":["2017-2022-6-7l-powerstroke"],
      "2022":["2017-2022-6-7l-powerstroke"]
    },
    "7.3L Powerstroke": {
      "1994":["1994-1997-7-3l-powerstroke"],
      "1995":["1994-1997-7-3l-powerstroke"],
      "1996":["1994-1997-7-3l-powerstroke"],
      "1997":["1994-1997-7-3l-powerstroke"],
      "1999":["1999-2003-7-3l-powerstroke"], 
      "2000":["1999-2003-7-3l-powerstroke"], 
      "2001":["1999-2003-7-3l-powerstroke"], 
      "2002":["1999-2003-7-3l-powerstroke"], 
      "2003":["1999-2003-7-3l-powerstroke"]
    }
  },

  
  "Ram": {
    "5.9L 12V Cummins": {
      "1989":["1989-1993-5-9l-12v-cummins"],
      "1990":["1989-1993-5-9l-12v-cummins"],
      "1991":["1989-1993-5-9l-12v-cummins"],
      "1992":["1989-1993-5-9l-12v-cummins"],
      "1993":["1989-1993-5-9l-12v-cummins"],
      "1994":["1994-1998-5-9l-12v-cummins"],
      "1995":["1994-1998-5-9l-12v-cummins"],
      "1996":["1994-1998-5-9l-12v-cummins"],
      "1997":["1994-1998-5-9l-12v-cummins"],
      "1998":["1994-1998-5-9l-12v-cummins"]
    },
    "5.9L 24V Cummins": {
      "1998":["1998-5-2002-5-9l-24v-cummins"], 
      "1999":["1998-5-2002-5-9l-24v-cummins"], 
      "2000":["1998-5-2002-5-9l-24v-cummins"], 
      "2001":["1998-5-2002-5-9l-24v-cummins"], 
      "2002":["1998-5-2002-5-9l-24v-cummins"], 
      "2003":["2003-2004-5-9l-24v-cummins"], 
      "2004":["2003-2004-5-9l-24v-cummins"],
      "2005":["2004-5-2007-5-9l-cummins"],
      "2006":["2004-5-2007-5-9l-cummins"],
      "2007":["2004-5-2007-5-9l-cummins"]
    },
    "6.7L 24V Cummins": {
      "2007":["2007-5-2018-6-7l-24v-cummins"], 
      "2008":["2007-5-2018-6-7l-24v-cummins"], 
      "2009":["2007-5-2018-6-7l-24v-cummins"], 
      "2010":["2007-5-2018-6-7l-24v-cummins"], 
      "2011":["2007-5-2018-6-7l-24v-cummins"], 
      "2012":["2007-5-2018-6-7l-24v-cummins"], 
      "2013":["2007-5-2018-6-7l-24v-cummins"], 
      "2014":["2007-5-2018-6-7l-24v-cummins"], 
      "2015":["2007-5-2018-6-7l-24v-cummins"], 
      "2016":["2007-5-2018-6-7l-24v-cummins"], 
      "2017":["2007-5-2018-6-7l-24v-cummins"], 
      "2018":["2007-5-2018-6-7l-24v-cummins"], 
      "2019":["2019-2022-6-7l-24v-cummins"], 
      "2020":["2019-2022-6-7l-24v-cummins"],
      "2021":["2019-2022-6-7l-24v-cummins"], 
      "2022":["2019-2022-6-7l-24v-cummins"]
    }
  },
  "GM/Chevrolet": {
    "6.6L L5P Duramax": {
      "2017":["2017-2019-6-6l-l5p-duramax"], 
      "2018":["2017-2019-6-6l-l5p-duramax"], 
      "2019":["2017-2019-6-6l-l5p-duramax"], 
      "2020":["2020-2022-6-6l-l5p-duramax"], 
      "2021":["2020-2022-6-6l-l5p-duramax"], 
      "2022":["2020-2022-6-6l-l5p-duramax"]
    },
    "6.6L LML Duramax": {
      "2011":["2011-2016-6-6l-lml-duramax"], 
      "2012":["2011-2016-6-6l-lml-duramax"], 
      "2013":["2011-2016-6-6l-lml-duramax"], 
      "2014":["2011-2016-6-6l-lml-duramax"], 
      "2015":["2011-2016-6-6l-lml-duramax"], 
      "2016":["2011-2016-6-6l-lml-duramax"]
    },
    "6.6L LMM Duramax": {
      "2007":["2007-5-2010-6-6l-lmm-duramax"], 
      "2008":["2007-5-2010-6-6l-lmm-duramax"], 
      "2009":["2007-5-2010-6-6l-lmm-duramax"], 
      "2010":["2007-5-2010-6-6l-lmm-duramax"]
    },
    "6.6L LLY/LBZ Duramax": {
      "2006":["2006-2007-6-6l-lly-lbz-duramax"], 
      "2007":["2006-2007-6-6l-lly-lbz-duramax"]
    },
    "6.6L LLY": {
      "2004":["2004-5-2005-6-6l-lly-duramax"], 
      "2005":["2004-5-2005-6-6l-lly-duramax"]
    },
    "6.6L LB7": {
      "2001":["2001-2004-6-6l-lb7-duramax"], 
      "2002":["2001-2004-6-6l-lb7-duramax"], 
      "2003":["2001-2004-6-6l-lb7-duramax"], 
      "2004":["2001-2004-6-6l-lb7-duramax"]
    }
  }
}